import axios from 'axios';
import { API_URL } from '../config';

const URL_PRICE = `${API_URL}/price/appa`;
const APPA_CASCO_URL_PRICE = `${API_URL}/price/appacasco`;

export const requestPrice = (params) => axios.post(URL_PRICE, params)
  .then((response) => response.data && response.data.result);

export const requestCascoPrices = (payload) => axios
  .post(APPA_CASCO_URL_PRICE, payload)
  .then((response) => response.data);
